import axios from 'axios';

function getPhotosBaseUrl() {
    return process.env.REACT_APP_PHOTOS_URL;
}

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL
});

const authTokenKey = 'auth_token';

function setAuthToken(token, navigate) {
    localStorage.setItem(authTokenKey, token);
    window.dispatchEvent(new Event('auth-token-changed'));

    navigate('/');
}

function getAuthToken() {
    return localStorage.getItem(authTokenKey);
}

function isAuthenticated() {
    return !!localStorage.getItem(authTokenKey);
}

function logout() {
    localStorage.removeItem(authTokenKey);
    window.dispatchEvent(new Event('auth-token-changed'));

    window.location.href = '/login';
}

function redirectToUnauthorized() {
    window.location.href = '/unauthorized';
}

function redirectToNotFound() {
    window.location.href = '/not-found';
}

function redirectToApiUnavailable() {
    if (window.location.pathname === '/api-unavailable') {
        return;
    }

    window.location.href = '/api-unavailable';
}

function getStatusCode(err) {
    const statusCode = err?.response?.status ?? err?.status ?? err?.request?.status;

    if (Number.isInteger(statusCode) && statusCode > 0) {
        return statusCode;
    }

    return undefined;
}

async function login(path, data, authorized, setMessage = () => {}, onSuccess, onError = () => {}, onFinally = () => {},) {
    await api.post(path, data, {
        headers: handleApiHeaders(authorized)
    })
    .then((response) => {
        handleApiResponse(200, response, onSuccess, onError, onFinally);
        onFinally();
    })
    .catch((err) => {
        const statusCode = getStatusCode(err);

        if (statusCode === 401) {
            setMessage({ type: 'warning', text: 'Usuário ou senha incorretos.' });
            onFinally();
            return;
        }

        handleApiError(err, setMessage, onError, onFinally, 'none', 'redirect');
    });
}

async function post(path, data, authorized, setMessage = () => {}, onSuccess, onError = () => {}, onFinally = () => {}, unauthorizedAction = 'logout', notFoundAction = 'redirect', networkFailureAction = 'api-unavailable') {
    await api.post(path, data, {
        headers: handleApiHeaders(authorized)
    })
    .then((response) => {
        handleApiResponse(200, response, onSuccess, onError, onFinally);
        onFinally();
    })
    .catch((err) => {
        handleApiError(err, setMessage, onError, onFinally, unauthorizedAction, notFoundAction, networkFailureAction);
    });
}

    async function create(path, data, authorized, setMessage = () => {}, onSuccess, onError = () => {}, onFinally = () => {}, unauthorizedAction = 'logout', notFoundAction = 'redirect', networkFailureAction = 'api-unavailable') {
    await api.post(path, data, {
        headers: handleApiHeaders(authorized)
    })
    .then((response) => {
        handleApiResponse(201, response, onSuccess, onError, onFinally);
    })
    .catch((err) => {
        handleApiError(err, setMessage, onError, onFinally, unauthorizedAction, notFoundAction, networkFailureAction);
    });
}

    async function put(path, data, authorized, setMessage = () => {}, onSuccess, onError = () => {}, onFinally = () => {}, unauthorizedAction = 'logout', notFoundAction = 'redirect', networkFailureAction = 'api-unavailable') {
    await api.put(path, data, {
        headers: handleApiHeaders(authorized)
    })
    .then((response) => {
        handleApiResponse(200, response, onSuccess, onError, onFinally);
    })
    .catch((err) => {
        handleApiError(err, setMessage, onError, onFinally, unauthorizedAction, notFoundAction, networkFailureAction);
    });
}

    async function remove(path, authorized, setMessage = () => {}, onSuccess, onError = () => {}, onFinally = () => {}, unauthorizedAction = 'logout', notFoundAction = 'redirect', networkFailureAction = 'api-unavailable') {
    await api.delete(path, {
        headers: handleApiHeaders(authorized)
    })
    .then((response) => {
        handleApiResponse(200, response, onSuccess, onError, onFinally);
    })
    .catch((err) => {
        handleApiError(err, setMessage, onError, onFinally, unauthorizedAction, notFoundAction, networkFailureAction);
    });
}

    async function get(path, authorized, setMessage = () => {}, onSuccess, onError = () => {}, onFinally = () => {}, unauthorizedAction = 'logout', notFoundAction = 'redirect', networkFailureAction = 'api-unavailable') {
    await api.get(path, {
        headers: handleApiHeaders(authorized)
    })
    .then((response) => {
        handleApiResponse(200, response, onSuccess, onError, onFinally);
    })
    .catch((err) => {
        handleApiError(err, setMessage, onError, onFinally, unauthorizedAction, notFoundAction, networkFailureAction);
    });
}

    async function getBlob(path, authorized, setMessage = () => {}, onSuccess, onError = () => {}, onFinally = () => {}, unauthorizedAction = 'logout', notFoundAction = 'redirect', networkFailureAction = 'api-unavailable') {
    await api.get(path, {
        responseType: 'blob',
        headers: handleApiHeaders(authorized)
    })
    .then((response) => {
        handleApiResponse(200, response, onSuccess, onError, onFinally);
    })
    .catch((err) => {
        handleApiError(err, setMessage, onError, onFinally, unauthorizedAction, notFoundAction, networkFailureAction);
    });
}

function handleApiHeaders(authorized) {
   let headers = {};
    if (!!authorized)
        headers.Authorization = `Bearer ${getAuthToken()}`
    
    return headers;
}

function handleApiResponse(successStatus, response, onSuccess, onError, onFinally) {
    try {
        if (response.status !== successStatus) {
            onError('O servidor não retornou um status esperado.');
            return;
        }

        onSuccess(response);
        onFinally();
    } catch (err) {
        onFinally();
        onError(err);
    }
}

function handleApiError(err, setMessage, onError, onFinally, unauthorizedAction = 'logout', notFoundAction = 'redirect', networkFailureAction = 'api-unavailable') {
    const statusCode = getStatusCode(err);

    const isNetworkFailure = !statusCode && !err?.response && err?.code !== 'ERR_CANCELED';
    if (isNetworkFailure) {
        onFinally();

        if (networkFailureAction === 'unauthorized') {
            redirectToUnauthorized();
            return;
        }

        redirectToApiUnavailable();
        return;
    }

    if (statusCode === 422) {
        setMessage({ type: 'warning', text: err.response.data[0].message });
        onFinally();
        return;
    }
    
    if (statusCode === 401) {
        if (unauthorizedAction === 'redirect') {
            onFinally();
            redirectToUnauthorized();
            return;
        }

        if (unauthorizedAction === 'logout') {
            onFinally();
            logout();
            return;
        }
    }

    if (statusCode === 403 && unauthorizedAction !== 'none') {
        onFinally();
        redirectToUnauthorized();
        return;
    }

    if (statusCode === 404 && notFoundAction === 'redirect') {
        onFinally();
        redirectToNotFound();
        return;
    }

    onError(err);
    onFinally();
}

export { setAuthToken, isAuthenticated, logout, login, create, post, put, remove, get, getBlob, getPhotosBaseUrl };